import { render, staticRenderFns } from "./info-block.vue?vue&type=template&id=98a5e1f2&"
import script from "./info-block.vue?vue&type=script&lang=js&"
export * from "./info-block.vue?vue&type=script&lang=js&"
import style0 from "./info-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a5e1f2')) {
      api.createRecord('98a5e1f2', component.options)
    } else {
      api.reload('98a5e1f2', component.options)
    }
    module.hot.accept("./info-block.vue?vue&type=template&id=98a5e1f2&", function () {
      api.rerender('98a5e1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/info-block/info-block.vue"
export default component.exports